<template>
  <div class="chart-container" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'StackedColumn',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    deep: true,
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      let xData = []
      let yData = []
      let legendData = []
      let showEchart = false
      let namenum = 0
      let option = {}
      if (this.data.data && this.data.data.length > 0) {
        xData = this.data.name
        yData = this.data.data

        for (let tempi in this.data.deviceData) {
          legendData.push(this.data.deviceData[tempi].name)
        }
        if (xData) {
          if (xData.length > 0) {
            namenum = Math.floor(100 / (xData.length / 5))
            if (xData.length > 5) {
              showEchart = true
            } else {
              showEchart = false
            }
          }
        }
        option = {
          title: {
            text: this.title,
            top: 0,
            x: '4%',
            textStyle: {
              fontSize: 14,
              fontWeight: 'normal'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '14'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff'
              }
            }
          },
          grid: {
            borderWidth: 0,
            top: '10%',
            left: '4%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
            textStyle: {
              color: '#fff'
            }
          },
          legend: {
            x: '4%',
            top: '5%',
            textStyle: {
              color: '#90979c'
            },
            // data: ['男', '女', '平均']
            data: legendData
          },
          color: ['#7BC3E0', '#2d8cf0', '#91CC75', '#fac858'],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              // axisLine: {
              //   lineStyle: {
              //     color: '#90979c'
              //   }
              // },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitArea: {
                show: false
              },
              axisLabel: {
                interval: 0,
                color: '#005eb8',

                // rotate: 10
                formatter: function (params) {
                  var newParamsName = ''
                  var paramsNameNumber = params.length
                  var provideNumber = 4 //一行显示几个字
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = ''
                      var start = p * provideNumber
                      var end = start + provideNumber
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber)
                      } else {
                        tempStr = params.substring(start, end) + '\n'
                      }
                      newParamsName += tempStr
                      if (newParamsName.length > 10) {
                        newParamsName = newParamsName.substring(0, 10) + '...'
                      }
                    }
                  } else {
                    newParamsName = params
                  }
                  return newParamsName
                }
              },

              data: xData
            }
          ],
          yAxis: [
            {
              type: 'value',
              min: (value) => {
                // return value.min
                return Math.floor(value.min / 100) * 100
              },
              max: (value) => {
                return Math.ceil(value.max)
                // return Math.ceil(value.max / 100) * 100
              },
              splitLine: {
                show: true
              }
            }
          ],

          dataZoom: [
            {
              type: 'slider',

              realtime: true,
              start: 0,
              end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
              height: 5, //组件高度
              left: 5, //左边的距离
              right: 5, //右边的距离
              bottom: 10, //下边的距离
              show: showEchart, // 是否展示
              fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
              borderColor: 'rgba(17, 100, 210, 0.12)',
              handleSize: 0, //两边手柄尺寸
              showDetail: false, //拖拽时是否展示滚动条两侧的文字
              zoomLock: true, //是否只平移不缩放
              moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
              //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

              //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
              startValue: 0, // 从头开始。
              endValue: 3, // 最多六个
              minValueSpan: 3, // 放大到最少几个
              maxValueSpan: 3 //  缩小到最多几个
            },
            {
              type: 'inside', // 支持内部鼠标滚动平移
              start: 0,
              end: namenum,
              zoomOnMouseWheel: false, // 关闭滚轮缩放
              moveOnMouseWheel: true, // 开启滚轮平移
              moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
            }
          ],
          series: yData
        }
      } else {
        option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center'
          }
        }
      }
      mychart.setOption(option, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
